import { render, staticRenderFns } from "./vuejswar.vue?vue&type=template&id=071b19ea&scoped=true&"
import script from "./vuejswar.vue?vue&type=script&lang=js&"
export * from "./vuejswar.vue?vue&type=script&lang=js&"
import style0 from "./vuejswar.vue?vue&type=style&index=0&id=071b19ea&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b19ea",
  null
  
)

export default component.exports